<script lang="ts">

    import Modal from "../Modal/Modal.svelte";
    import {ApiCall} from "../../services/ApiCall.ts";
    import {push} from "svelte-spa-router";
    import UserForm from "./UserForm.svelte";

    let gestionnaire = {
        gestionnaire_id: '',
        civility: '',
        first_name: '',
        last_name: '',
        email: '',
        phone: '',
        mobile: '',
        fax: '',
        password: '',
        passwordConfirmation: ''
    }

    let promise = getGestionnaireInfo();

    async function getGestionnaireInfo() {

        const apiCall = new ApiCall();

        try{
            const content = await apiCall.authenticatedPostRequest('applicateur/get_gestionnaire', null);

            if (content.success === false) {
                push('/erreur500')
            }
            else{

                gestionnaire.gestionnaire_id = content.data.gestionnaire_id;
                gestionnaire.civility = content.data.civility;
                gestionnaire.first_name = content.data.first_name;
                gestionnaire.last_name = content.data.last_name;
                gestionnaire.email = content.data.email;
                gestionnaire.phone = content.data.phone;
                gestionnaire.mobile = content.data.mobile;
                gestionnaire.fax = content.data.fax;

                return content.data;
            }
        }
        catch (e) {
            push('/erreur500')
        }
    }

    let userUpdateStatus:boolean = false;
    function handleForm(event) {

        userUpdateStatus = event.detail.requestStatus;

        if (event.detail.data !== '') {
            gestionnaire.civility = event.detail.data.civility;
            gestionnaire.first_name = event.detail.data.first_name;
            gestionnaire.last_name = event.detail.data.last_name;
            gestionnaire.email = event.detail.data.email;
            gestionnaire.phone = event.detail.data.phone;
            gestionnaire.mobile = event.detail.data.mobile;
            gestionnaire.fax = event.detail.data.fax;
            gestionnaire.password = '';
            gestionnaire.passwordConfirmation = '';
        }
    }
</script>

<h2 class="title is-2 has-text-centered mb-6">Mon compte</h2>

{#if userUpdateStatus}
    <div>
        <Modal title="Modifications réussies" type="validation">
            <svelte:fragment slot="button">
                <button on:click={() => {userUpdateStatus = false}} class="modal-close is-large" aria-label="close"></button>
            </svelte:fragment>
            <svelte:fragment slot="buttons-container">
                <button on:click={() => {userUpdateStatus = false}} class="button-close button is-info">Fermer</button>
            </svelte:fragment>
        </Modal>
    </div>
{/if}

{#await promise}
    <Modal title="Chargement des informations" type="loader"/>
{:then data}
    <UserForm gestionnaire={gestionnaire} on:submittedForm={handleForm}/>
{/await}